import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Search, X } from "lucide-react";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";

export function FilterBar({ filters, options, onChange, onReset }) {
    if (!options) return null;
    const Sel = ({ label, value, onValueChange, choices, testid }) => (
        <Select value={value} onValueChange={onValueChange}>
            <SelectTrigger
                className="rounded-none h-12 border-foreground bg-background uppercase tracking-widest text-xs font-bold"
                data-testid={testid}
            >
                <SelectValue placeholder={label} />
            </SelectTrigger>
            <SelectContent className="rounded-none">
                <SelectItem value="All" className="rounded-none uppercase tracking-widest text-xs">
                    All {label}
                </SelectItem>
                {choices.map((c) => (
                    <SelectItem key={c} value={c} className="rounded-none">
                        {c}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );

    return (
        <div className="grid grid-cols-1 md:grid-cols-12 gap-3 items-stretch" data-testid="filter-bar">
            <div className="md:col-span-4 relative">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                <Input
                    placeholder="SEARCH STUDIO / NEIGHBORHOOD / CLASS"
                    value={filters.search}
                    onChange={(e) => onChange({ search: e.target.value })}
                    className="rounded-none h-12 border-foreground pl-9 placeholder:uppercase placeholder:tracking-widest placeholder:text-xs"
                    data-testid="search-input"
                />
                {filters.search && (
                    <button
                        onClick={() => onChange({ search: "" })}
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
                        aria-label="Clear search"
                    >
                        <X className="h-4 w-4" />
                    </button>
                )}
            </div>
            <div className="md:col-span-2">
                <Sel
                    label="Category"
                    value={filters.category}
                    onValueChange={(v) => onChange({ category: v })}
                    choices={options.categories}
                    testid="filter-category"
                />
            </div>
            <div className="md:col-span-2">
                <Sel
                    label="Borough"
                    value={filters.borough}
                    onValueChange={(v) => onChange({ borough: v })}
                    choices={options.boroughs}
                    testid="filter-borough"
                />
            </div>
            <div className="md:col-span-2">
                <Sel
                    label="Audience"
                    value={filters.women_focus}
                    onValueChange={(v) => onChange({ women_focus: v })}
                    choices={options.women_focus}
                    testid="filter-women-focus"
                />
            </div>
            <div className="md:col-span-2 flex gap-2">
                <Sel
                    label="Level"
                    value={filters.skill_level}
                    onValueChange={(v) => onChange({ skill_level: v })}
                    choices={options.skill_levels}
                    testid="filter-skill"
                />
                <Button
                    variant="outline"
                    onClick={onReset}
                    className="rounded-none border-foreground h-12 uppercase tracking-widest hover-invert"
                    data-testid="reset-filters-btn"
                >
                    Reset
                </Button>
            </div>
        </div>
    );
}
